import Home from "./pages/home/Home";

function App() {
  return <Home></Home>;
}

export default App;
